module.exports = __webpack_public_path__ + "img/logout.d59e1ae7.svg";